module.exports = __webpack_public_path__ + "img/18a001-03.998bb36d.jpg";